import { render } from "./InputMultipleCheckbox.vue?vue&type=template&id=9257bfe6"
import script from "./InputMultipleCheckbox.vue?vue&type=script&lang=js"
export * from "./InputMultipleCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__